module.exports = __webpack_public_path__ + "img/6.c5522c45.webp";